<template>
	<div class="password-validation">
		<div>
			<Criteria :success="hasCompleteLength()">
				{{ translation['min-eight-characters'] }}
			</Criteria>
			<Criteria :success="hasAtLeastOneLowerCase()">
				{{ translation['min-one-lower-case'] }}
			</Criteria>
			<Criteria :success="hasAtLeastOneUpperCase()">
				{{ translation['min-one-upper-case'] }}
			</Criteria>
		</div>
		<div>
			<Criteria :success="hasAtLeastOneNumber()">
				{{ translation['min-one-number'] }}
			</Criteria>
			<Criteria :success="hasAtLeastOneSpecialCaracter()">
				{{ translation['min-one-special-character'] }}
			</Criteria>
		</div>
	</div>
</template>

<script>
import { translationMixin } from '@/mixins';
import Criteria from '@/components/Criteria';

export default {
	name: 'Validation',
	components: {
		Criteria,
	},
	mixins: [translationMixin],
	props: {
		password: {
			type: String,
			required: true,
		},
	},
	computed: {
		translation() {
			return this.currentTranslation['password-validation'];
		},
	},
	watch: {
		password() {
			this.$emit('validation', this.isAllRulesRespected());
			this.$emit('special-character', this.hasAtLeastOneSpecialCaracter());
		},
	},
	methods: {
		hasCompleteLength() {
			return this.password.length >= 8;
		},

		hasAtLeastOneNumber() {
			return /\d/.test(this.password);
		},

		hasAtLeastOneLowerCase() {
			return /[a-z]/.test(this.password);
		},

		hasAtLeastOneUpperCase() {
			return /[A-Z]/.test(this.password);
		},

		hasAtLeastOneSpecialCaracter() {
			const format = /[$*.^[\]{}()?\-"!@#%&/\\,><':;|_~`?]+/;
			return format.test(this.password);
		},

		isAllRulesRespected() {
			return this.hasCompleteLength() && this.hasAtLeastOneNumber()
			&& this.hasAtLeastOneLowerCase() && this.hasAtLeastOneUpperCase()
			&& this.hasAtLeastOneSpecialCaracter();
		},
	},
};
</script>

<style scoped lang="scss" src="./validation.scss" />
